import { LegendStates, MouseSelectionStates, SelectedParams } from "types";

import { mpcCompatibleHoverLegends, mpcCompatibleSelectionParams } from "./mpcHighlights";

export function rateDateHoverLegends(states: Partial<MouseSelectionStates>) {
  return mpcCompatibleHoverLegends(states);
}

export function rateDateSelectionParams(states: Partial<LegendStates>): SelectedParams {
  return mpcCompatibleSelectionParams(states);
}
